<template>
  <div v-if="show" class="login-overlay">
    <slot v-if="hasAuthErrors" class="error msg-error"></slot>
    <v-btn v-if="displayLogoutButton" class="overlay-btn" @click="logout()">
      Sign Out
    </v-btn>
    <slot v-if="hasErrors" class="error msg-error"></slot>
    <v-btn v-if="hasErrors" class="overlay-btn" @click="dismiss()">
      Dismiss
    </v-btn>
    <div class="loading-logo"></div>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  computed: {
    hasErrors() {
      return this.$store.state.error.length
    },
    hasAuthErrors() {
      return !!this.$store.state.authError
    },
    show() {
      return this.$store.state.overlay
    },
    displayLogoutButton() {
      const init = this?.$store?.getters?.initialized
      if (!init) {
        return false
      }
      const teamErrors = this.$store.state.teamList.errors
      const userErrors = this.$store.state.user.errors
      const allErrors = [...teamErrors, ...userErrors]
      // TODO Better way to display errors to the user
      if (allErrors.length || this.hasAuthErrors) {
        for (const error of allErrors) {
          this.$toast.error(error)
        }
        return true
      }
      return false
    },
  },
  methods: {
    logout() {
      this.$cookie.delete("disabled-animation")
      this.$cookie.delete("circular-animation")
      this.$store.dispatch("logout")
      if (this.$router.currentRoute.path !== "/login") {
        this.$router.replace("/login")
      }
      this.$store.commit("setOverlay", false)
    },
    dismiss() {
      this.$store.commit("setOverlay", false)
    },
  },
}
</script>

<style lang="sass" scoped>
@import "../../../assets/sass/variables"
.login-overlay
  z-index: 999999
  width: 100%
  position: fixed
  background-color: rgba(0, 0, 0, 0.5)
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  height: 100vh
  padding-top: 45px

  .msg-error
    position: absolute
    z-index: 999
    color: white
    padding: 10px
    border-radius: 10px
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)

  .loading-logo
    background: url('../../../assets/logos/loading-logo.png') center center no-repeat
    background-size: cover
    height: 130px
    width: 130px
    position: relative
    opacity: 0.9
    border-radius: 100%
    box-shadow: 0 0 10px white inset

  .overlay-btn
    border: 0
    background-color: $peach !important
    color: white
    font-weight: bold
    // left: 50%
    // transform: translateX(-50%)
    margin: 0
    padding: 20px
    position: absolute
    text-transform: none
    top: 0
    height: 3.41rem !important
    width: 10.05rem !important

// modern browser do not support apng format
@media only screen and (-webkit-device-pixel-ratio: 1.5)
 .login-overlay
   .loading-logo
     background-image: url("/static/loading-logo.webp")

// MS IE 11
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
  .login-overlay
    .loading-logo
      background-image: url("../../../assets/logos/loading-logo.gif")

// MS Edge
@supports (-ms-accelerator: true)
 .login-overlay
   .loading-logo
     background-image: url("/static/loading-logo.webp")
</style>
